const getCLABE = (meta) => {
  const regEx = /(\d{3})(\d{3})(\d{4})(\d{7})(\d)/;

  return meta.clabe.replace(regEx, '$1 $2 $3 $4 $5');
};

export default getCLABE;
